// A "Dictate" button for any text box: speech becomes text (Albanian, English or German), added to what's there.
import { useEffect, useRef, useState } from "react";
import { Icon, useStudio } from "./ui";
import { dictate } from "../lib/speech";
import { cleanError } from "../lib/m365";
import { L } from "../lib/i18n";

export function DictateButton({ onText }: { onText: (text: string) => void }) {
  const { toast, getToken, consent, openConsent } = useStudio();
  const [listening, setListening] = useState(false);
  const stop = useRef<(() => void) | null>(null);
  useEffect(() => () => stop.current?.(), []);
  async function toggle() {
    if (listening) { stop.current?.(); stop.current = null; setListening(false); return; }
    if (!consent.mic) { toast(L("Turn on the microphone in Privacy & consent first.", "Aktivizo më parë mikrofonin te Privatësia dhe pëlqimi.")); openConsent(); return; }
    try {
      stop.current = await dictate(getToken, onText, () => { toast(L("Dictation stopped. Please try again.", "Diktimi u ndal. Provo përsëri.")); setListening(false); });
      setListening(true);
    } catch (e) { toast(cleanError(e)); }
  }
  return (
    <button type="button" className={`btn ${listening ? "on" : ""}`} aria-pressed={listening} onClick={() => void toggle()}>
      <Icon name="mic" size={15} /> {listening ? L("Stop dictating", "Ndalo diktimin") : L("Dictate", "Dikto")}
    </button>
  );
}
